import { render, staticRenderFns } from "./MDropMenu.vue?vue&type=template&id=4bfa59fc"
import script from "./MDropMenu.vue?vue&type=script&lang=js"
export * from "./MDropMenu.vue?vue&type=script&lang=js"
import style0 from "./MDropMenu.vue?vue&type=style&index=0&id=4bfa59fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports